import Vue from 'vue'
import VueI18n from 'vue-i18n'
// default language
import * as enUSLang from './lang/en-US'
import * as zhCNLang from './lang/zh-CN'

Vue.use(VueI18n)

const messages = {
  'zh-CN': {
    ...zhCNLang
  },
  'en-US': {
    ...enUSLang
  }
}
export const defaultLang = 'zh-CN'

const i18n = new VueI18n({
  locale: defaultLang,
  fallbackLocale: defaultLang,
  messages
})

export default i18n

// 中英文资源已在上方静态注册，首屏切换时不需要再次等待动态加载。
const loadedLanguages = [defaultLang, 'en-US']

function setI18nLanguage (lang) {
  i18n.locale = lang
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export async function loadLanguageAsync (lang = defaultLang) {
  if (i18n.locale === lang) return setI18nLanguage(lang)

  if (!loadedLanguages.includes(lang)) {
    const msg = await import(/* webpackChunkName: "lang-[request]" */ `./lang/${lang}`)
    i18n.setLocaleMessage(lang, msg)
    loadedLanguages.push(lang)
  }

  return setI18nLanguage(lang)
}
